import { Page } from "containers/Page";
import { TabsStyled } from "features/Login/components/LoginBox/style";
import { useState } from "react";
import { Tab } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { LotesSolicitados } from "./containers/LotesSolicitados";
import { Solicitacoes } from "./containers/Solicitacoes";
import {
  ABA_LOTES,
  ABA_SOLICITACOES,
} from "./constants/navegacaoSolicitacaoPlaca";
import { TIPO_SOLICITACAO_PLACA } from "./constants/tipoSolicitacaoPlaca";
import { useTotalPendentes } from "./hooks/useTotalPendentes";
import { IEstadoVoltaSolicitacaoPlaca } from "./interfaces/INavegacaoSolicitacaoPlaca";

export function SolicitacaoPlaca() {
  const tipo = TIPO_SOLICITACAO_PLACA.INOVA;
  const location = useLocation();
  const [volta] = useState(() => {
    const estado = location.state as IEstadoVoltaSolicitacaoPlaca | null;
    // history.state sobrevive ao reload: descarta filtros do formato antigo (idLote em texto)
    if (estado?.lotes && !Array.isArray(estado.lotes.filtros?.idLote)) {
      return { ...estado, lotes: undefined };
    }
    return estado;
  });
  const [tab, setTab] = useState(volta?.aba ?? ABA_SOLICITACOES);
  const { total: totalSolicitacoes, recarregarTotal } = useTotalPendentes(tipo);

  function selecionarAba(chave: string | null) {
    setTab(chave as string);
  }

  return (
    <Page lastPage="Home / Inova" title="Solicitação de placa">
      <TabsStyled
        host=""
        id="tabs-solicitacao-placa"
        className="mt-4"
        activeKey={tab}
        onSelect={selecionarAba}
      >
        <Tab
          eventKey={ABA_SOLICITACOES}
          title={`Solicitações (${totalSolicitacoes})`}
        >
          <Solicitacoes tipo={tipo} onTotalAlterado={recarregarTotal} />
        </Tab>
        <Tab eventKey={ABA_LOTES} title="Lotes solicitados">
          <LotesSolicitados
            tipo={tipo}
            ativa={tab === ABA_LOTES}
            estadoInicial={volta?.lotes}
          />
        </Tab>
      </TabsStyled>
    </Page>
  );
}
